<template>
  <ul :class="{ 'uk-navbar-nav top-nav': type === 'top', 'uk-nav uk-nav-primary uk-nav-center uk-margin-auto-vertical side-nav': type === 'side'}" data-cy="navigation">
    <li>
      <router-link :to="{ name: 'dashboard' }" data-cy="nav-btn-dashboard">Dashboard</router-link>
    </li>

    <template v-if="$store.getters['account/type'] === 'admin'">
      <template v-if="type === 'top'">
        <li>
          <a class="drop-button" :class="{ 'router-link-exact-active': $route.meta.navbarGroup === 'users' }" data-cy="nav-btn-admin-users">Users</a>
          <div id="navdrop" uk-drop="mode: hover; pos: bottom-center; offset: 35;">
            <div class="navbar-drop">
              <router-link tag="div" class="uk-button uk-button-primary" :to="{ name: 'dentist-list' }" data-cy="nav-btn-admin-users-dentists">Dentists</router-link>
              <router-link tag="div" class="uk-button uk-button-primary" :to="{ name: 'operator-list' }" data-cy="nav-btn-admin-users-operators">Operators</router-link>
              <router-link tag="div" class="uk-button uk-button-primary" :to="{ name: 'admin-list' }" data-cy="nav-btn-admin-users-admins">Admins</router-link>
            </div>
          </div>
        </li>
      </template>

      <template v-if="type === 'side'">
        <li>
          <router-link :to="{ name: 'dentist-list' }" :class="linkClass">Dentists</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'operator-list' }" :class="linkClass">Operators</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'admin-list' }" :class="linkClass">Admins</router-link>
        </li>
      </template>

      <li>
        <router-link :to="{ name: 'ticket-list' }" :class="linkClass">Tickets</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'enquiry-list' }" :class="linkClass">Enquiries</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'request-list' }" :class="linkClass">Requests</router-link>
      </li>
    </template>

    <template v-if="$store.getters['account/type'] === 'operator'">
      <li>
        <router-link :to="{ name: 'dentist-list' }" :class="linkClass">Dentists</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'appointment-list' }" :class="linkClass">Appointments</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'enquiry-list' }" :class="linkClass">Enquiries</router-link>
      </li>
    </template>

    <template v-if="$store.getters['account/type'] === 'dentist'">
      <li>
        <router-link :to="{ name: 'appointment-list' }" :class="linkClass" data-cy="topbar-appointments">Appointments</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'dentist-availability-view' }" :class="linkClass" data-cy="topbar-availability">Availability</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'dentist-practice-view' }" :class="linkClass" data-cy="topbar-practice">Practice</router-link>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  name: 'ComponentNavigation',

  props: {
    type: {
      type: String,
      required: true,
      validator(value) {
        // The value must match one of these strings
        return ['top', 'side'].indexOf(value) !== -1
      }
    }
  },

  data() {
    return {
      linkClass: 'side-nav-link'
    }
  }
}
</script>

<style lang="scss" scoped>
.uk-navbar-nav {
  li:hover > a,
  .drop-button.uk-open {
    color: $colour-light;
  }

  a {
    transition: background-color 200ms ease;
    background-color: transparent;
    color: $colour-light;

    &.router-link-exact-active {
      background-color: $colour-light;
      color: $colour-primary;

      &:hover,
      &:active,
      &:focus {
        color: $colour-primary;
      }
    }
  }

  a.drop-button.uk-open:not(.router-link-exact-active) {
    background-color: $colour-primary-dark;
  }

  .uk-drop {
    width: auto;

    .navbar-drop {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
